// Basic pages
import Homepage from "../pages/Homepage"
import NotFound from "../pages/NotFound"

// Base
import GettingStarted from "../pages/GettingStarted"
import ListPage from "../pages/ListPage"

// Styles
import ColorsPage from "../pages/styles/ColorsPage"
import FontsPage from "../pages/styles/FontsPage"
import ShadowsPage from "../pages/styles/ShadowsPage"
import RadiusesPage from "../pages/styles/RadiusesPage"

// Layouts
import ContainerPage from "../pages/layouts/ContainerPage"
import SectionPage from "../pages/layouts/SectionPage"
import SpacersPage from "../pages/layouts/SpacersPage"
import GridPage from "../pages/layouts/GridPage"
import FlexboxPage from "../pages/layouts/FlexboxPage"

// Fajny Icons
import ListIconsPage from "../pages/icons/ListIconsPage"
import IconDetailPage from "../pages/icons/IconDetailPage"

// Components
import IconPage from "../pages/components/IconPage"
import HrPage from "../pages/components/HrPage"
import ImagePage from "../pages/components/ImagePage"
import VideoPage from "../pages/components/VideoPage"
import YoutubePage from "../pages/components/YoutubePage"
import AvatarPage from "../pages/components/AvatarPage"
import LoaderPage from "../pages/components/LoaderPage"
import ButtonPage from "../pages/components/ButtonPage"
import ButtonIconPage from "../pages/components/ButtonIconPage"
import TagPage from "../pages/components/TagPage"
import BadgePage from "../pages/components/BadgePage"
import TooltipPage from "../pages/components/TooltipPage"
import InputPage from "../pages/components/InputPage"
import InputImagePage from "../pages/components/InputImagePage"
import InputCheckPage from "../pages/components/InputCheckPage"
import FormPage from "../pages/components/FormPage"
import BreadcrumbsPage from "../pages/components/BreadcrumbsPage"
import AccordionPage from "../pages/components/AccordionPage"
import DropdownPage from "../pages/components/DropdownPage"
import ToastPage from "../pages/components/ToastPage"
import AlertPage from "../pages/components/AlertPage"
import ModalPage from "../pages/components/ModalPage"
import PaginationPage from "../pages/components/PaginationPage"
import PaginatorPage from "../pages/components/PaginatorPage"
import StepperPage from "../pages/components/StepperPage"
import ProgressBarPage from "../pages/components/ProgressBarPage"
import TabsPage from "../pages/components/TabsPage"
import SlideshowPage from "../pages/components/SlideshowPage"
import BurgerPage from "../pages/components/BurgerPage"
import CardBasicPage from "../pages/components/CardBasicPage"
import CardImagePage from "../pages/components/CardImagePage"
import CardActionPage from "../pages/components/CardActionPage"
import CoverPage from "../pages/components/CoverPage"
import TablePage from "../pages/components/TablePage"
import PageLoadingPage from "../pages/components/PageLoadingPage"
import CodeContainerPage from "../pages/components/CodeContainerPage"
import HeaderPage from "../pages/components/HeaderPage"
import FooterPage from "../pages/components/FooterPage"

// Helpers
import VariablesPage from "../pages/helpers/VariablesPage"
import MixinsPage from "../pages/helpers/MixinsPage"
import HelpersPage from "../pages/helpers/HelpersPage"
import JsUtilsPage from "../pages/helpers/JsUtilsPage"
import SrOnlyPage from "../pages/helpers/SrOnlyPage"

const routes = [
    {
        path: "/",
        element: Homepage,
    },
    {
        path: "*",
        element: NotFound,
    },

    {
        path: "/getting-started",
        element: GettingStarted,
    },
    {
        path: "/:category",
        element: ListPage,
    },

    {
        path: "/styles/colors",
        element: ColorsPage,
    },
    {
        path: "/styles/fonts",
        element: FontsPage,
    },
    {
        path: "/styles/shadows",
        element: ShadowsPage,
    },
    {
        path: "/styles/radiuses",
        element: RadiusesPage,
    },

    {
        path: "/layouts/container",
        element: ContainerPage,
    },
    {
        path: "/layouts/section",
        element: SectionPage,
    },
    {
        path: "/layouts/spacers",
        element: SpacersPage,
    },
    {
        path: "/layouts/grid",
        element: GridPage,
    },
    {
        path: "/layouts/flexbox",
        element: FlexboxPage,
    },

    {
        path: "/icons",
        element: ListIconsPage,
    },
    {
        path: "/icons/:iconName",
        element: IconDetailPage,
    },

    {
        path: "/components/icon",
        element: IconPage,
    },
    {
        path: "/components/hr",
        element: HrPage,
    },
    {
        path: "/components/image",
        element: ImagePage,
    },
    {
        path: "/components/video",
        element: VideoPage,
    },
    {
        path: "/components/youtube",
        element: YoutubePage,
    },
    {
        path: "/components/avatar",
        element: AvatarPage,
    },
    {
        path: "/components/loader",
        element: LoaderPage,
    },
    {
        path: "/components/button",
        element: ButtonPage,
    },
    {
        path: "/components/button-icon",
        element: ButtonIconPage,
    },
    {
        path: "/components/tag",
        element: TagPage,
    },
    {
        path: "/components/badge",
        element: BadgePage,
    },
    {
        path: "/components/tooltip",
        element: TooltipPage,
    },
    {
        path: "/components/input",
        element: InputPage,
    },
    {
        path: "/components/input-image",
        element: InputImagePage,
    },
    {
        path: "/components/input-check",
        element: InputCheckPage,
    },
    {
        path: "/components/form",
        element: FormPage,
    },
    {
        path: "/components/breadcrumbs",
        element: BreadcrumbsPage,
    },
    {
        path: "/components/accordion",
        element: AccordionPage,
    },
    {
        path: "/components/dropdown",
        element: DropdownPage,
    },
    {
        path: "/components/toast",
        element: ToastPage,
    },
    {
        path: "/components/alert",
        element: AlertPage,
    },
    {
        path: "/components/modal",
        element: ModalPage,
    },
    {
        path: "/components/pagination",
        element: PaginationPage,
    },
    {
        path: "/components/paginator",
        element: PaginatorPage,
    },
    {
        path: "/components/stepper",
        element: StepperPage,
    },
    {
        path: "/components/progress-bar",
        element: ProgressBarPage,
    },
    {
        path: "/components/tabs",
        element: TabsPage,
    },
    {
        path: "/components/slideshow",
        element: SlideshowPage,
    },
    {
        path: "/components/burger",
        element: BurgerPage,
    },
    {
        path: "/components/card-basic",
        element: CardBasicPage,
    },
    {
        path: "/components/card-image",
        element: CardImagePage,
    },
    {
        path: "/components/card-action",
        element: CardActionPage,
    },
    {
        path: "/components/cover",
        element: CoverPage,
    },
    {
        path: "/components/table",
        element: TablePage,
    },
    {
        path: "/components/page-loading",
        element: PageLoadingPage,
    },
    {
        path: "/components/code-container",
        element: CodeContainerPage,
    },
    {
        path: "/components/header",
        element: HeaderPage,
    },
    {
        path: "/components/footer",
        element: FooterPage,
    },

    {
        path: "/helpers/variables",
        element: VariablesPage,
    },
    {
        path: "/helpers/mixins",
        element: MixinsPage,
    },
    {
        path: "/helpers/helpers",
        element: HelpersPage,
    },
    {
        path: "/helpers/js-utils",
        element: JsUtilsPage,
    },
    {
        path: "/helpers/sr-only",
        element: SrOnlyPage,
    },
]

export default routes
